"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUpdateUrl = void 0;
var _createUrl = require("./createUrl");
var _handleUrlUpdateError = require("./handleUrlUpdateError");
var _safeQuery = require("./safeQuery");
var _warnIfURLIsTooLong = require("./warnIfURLIsTooLong");
/* istanbul ignore file -- ESM only not testable (platform is working on it) */

const createUpdateUrl = router => (search, {
  history,
  shallow,
  scroll
}) => {
  if (!router.isReady) {
    return;
  }
  const {
    pathname,
    hash
  } = new URL(router.asPath, window.location.origin);
  const query = (0, _safeQuery.safeQuery)(search);
  const newUrl = (0, _createUrl.createUrl)(pathname, query, hash);
  (0, _warnIfURLIsTooLong.warnIfURLIsTooLong)(newUrl.toString());
  try {
    const action = history === 'push' ? router.push : router.replace;
    action(router, {
      pathname,
      query,
      hash
    }, {
      shallow,
      scroll
    }).catch(error => (0, _handleUrlUpdateError.handleUrlUpdateError)(newUrl, error));
  } catch {
    (0, _handleUrlUpdateError.handleUrlUpdateError)(newUrl);
  }
};
exports.createUpdateUrl = createUpdateUrl;
